import React from 'react';
import { EventHeaderDescription } from '../../views/vantage/event-components/content-types';
import { OffsetBootstrapColumnWrapper } from '../../views/vantage/event-components/layout';

const Welcome = (props) => {
  const { customerName, greeting, state, preStateDescriptionText, postStateDescriptionText } = props;
  const customerNameGreeting = `${greeting} ${customerName}`;
  const description = `${preStateDescriptionText} ${state} ${postStateDescriptionText}`;
  return (
    <React.Fragment>
      {customerName &&
        <div className="row">
          <div className="col-12" >
            <h4 className="person-name text-center">
              {customerNameGreeting}
            </h4>
          </div>
        </div>
      }
      <OffsetBootstrapColumnWrapper columnsWide={10} wrapInRow>
        <EventHeaderDescription description={description} />
      </OffsetBootstrapColumnWrapper>
    </React.Fragment>
  );
};

export default Welcome;
